import React from 'react';

export interface SelectProps
  extends React.DetailedHTMLProps<
    React.SelectHTMLAttributes<HTMLSelectElement>,
    HTMLSelectElement
  > {
  label?: string;
  defaultSelect?: number | string;
  optionsList?: { value: number; name: string }[];
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  function _Select(
    { label = '', onChange, defaultSelect, className = '', children, ...props },
    ref
  ) {
    return (
      <label className="block">
        {label !== '' ? (
          <span className="text-gray-300 text-sm font-arial font-extrabold mb-2 tracking-wider ">
            {label}
          </span>
        ) : null}
        <select
          ref={ref}
          defaultValue={defaultSelect}
          onChange={onChange}
          className={`border-[0.5px] text-gray-300  border-solid border-neutral-300  appearance-none outline-none block w-full rounded py-2 px-3 placeholder:text-neutral-100  ${className}`}
          {...props}
        >
          {children}
        </select>
      </label>
    );
  }
);
